import type { AxlPilotChatContext } from "../types/axlPilotContext";
import { getAxlPilotAssessmentSnapshot } from "./axlPilotAssessmentCache";
import { isLeafUnit } from "./assessmentUnitUtils";

export function buildAxlPilotChatContext(
  capabilityId: number | null | undefined,
  subCapabilityId: number | null | undefined
): AxlPilotChatContext | null {
  const assessment = getAxlPilotAssessmentSnapshot();
  if (!assessment || capabilityId == null) {
    return null;
  }

  const normalizedSubId = isLeafUnit(subCapabilityId)
    ? null
    : subCapabilityId != null
      ? Number(subCapabilityId)
      : null;

  return {
    assessment,
    capability_id: Number(capabilityId),
    sub_capability_id: normalizedSubId,
  };
}
